import { Link, useLoaderData } from "react-router-dom";
import * as API from "../services/antmedicos";
import Select from "react-select";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAntmedicosByID(params.antmedicosId);
}

export function AntmedicosItem(props) {
  const antmedicos = useLoaderData();
  const errorMessage = antmedicos.message;

  const antmedResp = antmedicos.meta?.antmedResp;
  const antmedFecha = antmedicos.meta?.metaFecha;
  const antmedTipo = antmedicos.meta && antmedicos.meta.antmedTipo ? antmedicos.meta.antmedTipo : "";
  const antmedFamRad = antmedicos.meta?.antmedFamRad;
  const antmedFamEsp = antmedicos.meta?.antmedFamEsp;
  const antmedFumadRad = antmedicos.meta?.antmedFumadRad;
  const antmedFumadEsp = antmedicos.meta?.antmedFumadEsp;
  const antmedFumadEspKey = antmedFumadEsp?.includes("otros");
  const antmedFumadOtr = antmedicos.meta?.antmedFumadOtr;
  const antmedCafeRad = antmedicos.meta?.antmedCafeRad;
  const antmedCafeEsp = antmedicos.meta?.antmedCafeEsp;
  const antmedSobredRad = antmedicos.meta?.antmedSobredRad;
  const antmedSobredEsp = antmedicos.meta?.antmedSobredEsp;
  const antmedVihRad = antmedicos.meta?.antmedVihRad;
  const antmedAccidRad = antmedicos.meta?.antmedAccidRad;
  const antmedAccidEsp = antmedicos.meta?.antmedAccidEsp;
  const antmedIntquirRad = antmedicos.meta?.antmedIntquirRad;
  const antmedIntquirEsp = antmedicos.meta?.antmedIntquirEsp;
  const antmedIntmedRad = antmedicos.meta?.antmedIntmedRad;
  const antmedIntmedEsp = antmedicos.meta?.antmedIntmedEsp;
  const antmedMedicRad = antmedicos.meta?.antmedMedicRad;
  const antmedMedicEsp = antmedicos.meta?.antmedMedicEsp;
  const antmedAprespRad = antmedicos.meta?.antmedAprespRad;
  const antmedAprespEsp = antmedicos.meta?.antmedAprespEsp;
  const antmedAprespEspKey = antmedAprespEsp?.some(item => item.label === 'Otros');
  const antmedAprespOtr = antmedicos.meta?.antmedAprespOtr;
  const antmedEnfcardRad = antmedicos.meta?.antmedEnfcardRad;
  const antmedEnfcardEsp = antmedicos.meta?.antmedEnfcardEsp;
  const antmedEnfcardEspKey = antmedEnfcardEsp?.some(item => item.label === 'Otros');
  const antmedEnfcardOtr = antmedicos.meta?.antmedEnfcardOtr;
  const antmedEnfvascRad = antmedicos.meta?.antmedEnfvascRad;
  const antmedEnfvascEsp = antmedicos.meta?.antmedEnfvascEsp;
  const antmedEnfvascEspKey = antmedEnfvascEsp?.some(item => item.label === 'Otros');
  const antmedEnfvascOtr = antmedicos.meta?.antmedEnfvascOtr;
  const antmedEnfdigestRad = antmedicos.meta?.antmedEnfdigestRad;
  const antmedEnfdigestEsp = antmedicos.meta?.antmedEnfdigestEsp;
  const antmedEnfdigestEspKey = antmedEnfdigestEsp?.some(item => item.label === 'Otros');
  const antmedEnfdigestOtr = antmedicos.meta?.antmedEnfdigestOtr;
  const antmedEnfintestRad = antmedicos.meta?.antmedEnfintestRad;
  const antmedEnfintestEsp = antmedicos.meta?.antmedEnfintestEsp;
  const antmedEnfintestEspKey = antmedEnfintestEsp?.some(item => item.label === 'Otros');
  const antmedEnfintestOtr = antmedicos.meta?.antmedEnfintestOtr;
  const antmedEnfpancRad = antmedicos.meta?.antmedEnfpancRad;
  const antmedEnfpancEsp = antmedicos.meta?.antmedEnfpancEsp;
  const antmedEnfpancEspKey = antmedEnfpancEsp?.some(item => item.label === 'Otros');
  const antmedEnfpancOtr = antmedicos.meta?.antmedEnfpancOtr;
  const antmedEnfrenalRad = antmedicos.meta?.antmedEnfrenalRad;
  const antmedEnfrenalEsp = antmedicos.meta?.antmedEnfrenalEsp;
  const antmedEnfrenalEspKey = antmedEnfrenalEsp?.some(item => item.label === 'Otros');
  const antmedEnfrenalOtr = antmedicos.meta?.antmedEnfrenalOtr;
  const antmedEnfurinRad = antmedicos.meta?.antmedEnfurinRad;
  const antmedEnfurinEsp = antmedicos.meta?.antmedEnfurinEsp;
  const antmedEnfurinEspKey = antmedEnfurinEsp?.some(item => item.label === 'Otros');
  const antmedEnfurinOtr = antmedicos.meta?.antmedEnfurinOtr;
  const antmedEnfgenitRad = antmedicos.meta?.antmedEnfgenitRad;
  const antmedEnfgenitEsp = antmedicos.meta?.antmedEnfgenitEsp;
  const antmedEnfgenitEspKey = antmedEnfgenitEsp?.some(item => item.label === 'Otros');
  const antmedEnfgenitOtr = antmedicos.meta?.antmedEnfgenitOtr;
  const antmedAltmenstRad = antmedicos.meta?.antmedAltmenstRad;
  const antmedAltmenstEsp = antmedicos.meta?.antmedAltmenstEsp;
  const antmedAltmenstEspKey = antmedAltmenstEsp?.some(item => item.label === 'Otros');
  const antmedAltmenstOtr = antmedicos.meta?.antmedAltmenstOtr;
  const antmedEmbarzRad = antmedicos.meta?.antmedEmbarzRad;
  const antmedEmbarzEsp = antmedicos.meta?.antmedEmbarzEsp;
  const antmedAbortRad = antmedicos.meta?.antmedAbortRad;
  const antmedAbortEsp = antmedicos.meta?.antmedAbortEsp;
  const antmedEnfmetabRad = antmedicos.meta?.antmedEnfmetabRad;
  const antmedEnfmetabEsp = antmedicos.meta?.antmedEnfmetabEsp;
  const antmedEnfmetabEspKey = antmedEnfmetabEsp?.some(item => item.label === 'Otros');
  const antmedEnfmetabOtr = antmedicos.meta?.antmedEnfmetabOtr;
  const antmedEnfpielRad = antmedicos.meta?.antmedEnfpielRad;
  const antmedEnfpielEsp = antmedicos.meta?.antmedEnfpielEsp;
  const antmedEnfpielEspKey = antmedEnfpielEsp?.some(item => item.label === 'Otros');
  const antmedEnfpielOtr = antmedicos.meta?.antmedEnfpielOtr;
  const antmedEnfhematRad = antmedicos.meta?.antmedEnfhematRad;
  const antmedEnfhematEsp = antmedicos.meta?.antmedEnfhematEsp;
  const antmedEnfhematEspKey = antmedEnfhematEsp?.some(item => item.label === 'Otros');
  const antmedEnfhematOtr = antmedicos.meta?.antmedEnfhematOtr;
  const antmedEnfsncsnpRad = antmedicos.meta?.antmedEnfsncsnpRad;
  const antmedEnfsncsnpEsp = antmedicos.meta?.antmedEnfsncsnpEsp;
  const antmedEnfsncsnpEspKey = antmedEnfsncsnpEsp?.some(item => item.label === 'Otros');
  const antmedEnfsncsnpOtr = antmedicos.meta?.antmedEnfsncsnpOtr;
  const antmedAltsuenRad = antmedicos.meta?.antmedAltsuenRad;
  const antmedAltsuenEsp = antmedicos.meta?.antmedAltsuenEsp;
  const antmedAltsuenEspKey = antmedAltsuenEsp?.some(item => item.label === 'Otros');
  const antmedAltsuenOtr = antmedicos.meta?.antmedAltsuenOtr;
  const antmedAltapetRad = antmedicos.meta?.antmedAltapetRad;
  const antmedAltapetEsp = antmedicos.meta?.antmedAltapetEsp;
  const antmedAltsexRad = antmedicos.meta?.antmedAltsexRad;
  const antmedAltsexEsp = antmedicos.meta?.antmedAltsexEsp;
  const antmedAltsexEspKey = antmedAltsexEsp?.some(item => item.label === 'Otros');
  const antmedAltsexOtr = antmedicos.meta?.antmedAltsexOtr;
  const antmedPatoculRad = antmedicos.meta?.antmedPatoculRad;
  const antmedPatoculEsp = antmedicos.meta?.antmedPatoculEsp;
  const antmedPatoculEspKey = antmedPatoculEsp?.some(item => item.label === 'Otros');
  const antmedPatoculOtr = antmedicos.meta?.antmedPatoculOtr;
  const antmedPatauditRad = antmedicos.meta?.antmedPatauditRad;
  const antmedPatauditEsp = antmedicos.meta?.antmedPatauditEsp;
  const antmedPatauditEspKey = antmedPatauditEsp?.some(item => item.label === 'Otros');
  const antmedPatauditOtr = antmedicos.meta?.antmedPatauditOtr;
  const antmedPatolfRad = antmedicos.meta?.antmedPatolfRad;
  const antmedPatolfEsp = antmedicos.meta?.antmedPatolfEsp;
  const antmedObs = antmedicos.meta?.antmedObs;

  const antmedDate = new Date(antmedicos.date);
  const diffDate = (Math.abs(new Date() - antmedDate) / 36e5);

  return (
    <>
      <div id='content'>
        {antmedicos.length === 0 ? (
          <div>Cargando...</div>
        ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='antmedResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedResp'
                      required
                      type='text'
                      readOnly
                      value={antmedResp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antmedFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedFecha'
                      required
                      type='date'
                      value={antmedFecha}
                      readOnly
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antmedTipo'>Tipo</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='antmedTipo'
                        readOnly
                        name='antmedTipo'
                        value={antmedTipo}
                      >
                        <option disabled value=''> -- Selecciona una opción --</option>
                        <option value='Valoración'>Valoración</option>
                        <option value='Ingreso'>Ingreso</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Antecedentes familiares</h3>
              <div className='grid--2col'>
                <div className='field key' data-key={antmedFamRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Alguno de sus familiares ha tenido o tiene problemas
                      médicos?
                    </label>
                    <label className='radio' htmlFor='antmedFamRadSi'>
                      <input
                        id='antmedFamRadSi'
                        name='antmedFamRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedFamRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedFamRadNo'>
                      <input
                        id='antmedFamRadNo'
                        name='antmedFamRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedFamRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedFamEsp'>
                    Especificar problemas médicos de sus familiares
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedFamEsp'
                      type='text'
                      readOnly
                      value={antmedFamEsp}
                    />
                  </div>
                </div>
              </div>
              <h3>Antecedentes personales</h3>
              <div className='grid--2col'>
                <div className='field key' data-key={antmedFumadRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿El paciente es fumador habitual?
                    </label>
                    <label className='radio' htmlFor='antmedFumadRadSi'>
                      <input
                        id='antmedFumadRadSi'
                        name='antmedFumadRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedFumadRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedFumadRadNo'>
                      <input
                        id='antmedFumadRadNo'
                        name='antmedFumadRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedFumadRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedFumadEspKey}>
                  <label htmlFor='antmedFumadEsp'>
                    Especificar
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='antmedFumadEsp'
                        name='antmedFumadEsp'
                        value={antmedFumadEsp}
                        readOnly
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='menos-10-cigar'>
                          Menos de 10 cigarrillos
                        </option>
                        <option value='10-20-cigar'>
                          Entre 10-20 cigarrillos
                        </option>
                        <option value='mas-20-cigar'>
                          Más de 20 cigarrillos
                        </option>
                        <option value='otros-cigar'>
                          Otros
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedFumadOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedFumadOtr'
                      type='text'
                      readOnly
                      value={antmedFumadOtr}
                    />
                  </div>
                </div>

                <div className='field key' data-key={antmedCafeRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Consume café habitualmente?
                    </label>
                    <label className='radio' htmlFor='antmedCafeRadSi'>
                      <input
                        id='antmedCafeRadSi'
                        name='antmedCafeRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedCafeRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedCafeRadNo'>
                      <input
                        id='antmedCafeRadNo'
                        name='antmedCafeRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedCafeRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedCafeEsp'>
                    ¿Cuántos cafés toma por día?
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedCafeEsp'
                      type='text'
                      readOnly
                      value={antmedCafeEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antmedSobredRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido algún episodio de sobredosis?
                    </label>
                    <label className='radio' htmlFor='antmedSobredRadSi'>
                      <input
                        id='antmedSobredRadSi'
                        name='antmedSobredRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedSobredRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedSobredRadNo'>
                      <input
                        id='antmedSobredRadNo'
                        name='antmedSobredRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedSobredRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedSobredEsp'>
                    Especificar detalles de sobredosis
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedSobredEsp'
                      type='text'
                      readOnly
                      value={antmedSobredEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antmedVihRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Tiene anticuerpos contra el VIH?
                    </label>
                    <label className='radio' htmlFor='antmedVihRadSi'>
                      <input
                        id='antmedVihRadSi'
                        name='antmedVihRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedVihRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedVihRadNo'>
                      <input
                        id='antmedVihRadNo'
                        name='antmedVihRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedVihRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className='field key' data-key={antmedAccidRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido algún accidente que le haya dejado secuela?
                    </label>
                    <label className='radio' htmlFor='antmedAccidRadSi'>
                      <input
                        id='antmedAccidRadSi'
                        name='antmedAccidRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedAccidRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAccidRadNo'>
                      <input
                        id='antmedAccidRadNo'
                        name='antmedAccidRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedAccidRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedAccidEsp'>Especificar accidente</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAccidEsp'
                      type='text'
                      readOnly
                      value={antmedAccidEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antmedIntquirRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sido sometido a alguna intervención quirúrgica?
                    </label>
                    <label className='radio' htmlFor='antmedIntquirRadSi'>
                      <input
                        id='antmedIntquirRadSi'
                        name='antmedIntquirRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedIntquirRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedIntquirRadNo'>
                      <input
                        id='antmedIntquirRadNo'
                        name='antmedIntquirRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedIntquirRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedIntquirEsp'>
                    Especificar intervención quirúrgica
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedIntquirEsp'
                      type='text'
                      readOnly
                      value={antmedIntquirEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antmedIntmedRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha padecido o padece alergia o intolerancia a algún
                      medicamento?
                    </label>
                    <label className='radio' htmlFor='antmedIntmedRadSi'>
                      <input
                        id='antmedIntmedRadSi'
                        name='antmedIntmedRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedIntmedRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedIntmedRadNo'>
                      <input
                        id='antmedIntmedRadNo'
                        name='antmedIntmedRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedIntmedRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedIntmedEsp'>
                    Especificar intolerancia a medicamento
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedIntmedEsp'
                      type='text'
                      readOnly
                      value={antmedIntmedEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antmedMedicRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Está actualmente tomando alguna medicación (no
                      psicofármacos)?
                    </label>
                    <label className='radio' htmlFor='antmedMedicRadSi'>
                      <input
                        id='antmedMedicRadSi'
                        name='antmedMedicRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedMedicRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedMedicRadNo'>
                      <input
                        id='antmedMedicRadNo'
                        name='antmedMedicRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedMedicRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedMedicEsp'>Especificar medicación</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedMedicEsp'
                      type='text'
                      readOnly
                      value={antmedMedicEsp}
                    />
                  </div>
                </div>
              </div>
              <h3>Exploración por aparatos</h3>
              <div className='grid--2col'>
                <div
                  className='field key'
                  data-key={antmedAprespRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad del aparato
                      respiratorio?
                    </label>
                    <label className='radio' htmlFor='antmedAprespRadSi'>
                      <input
                        id='antmedAprespRadSi'
                        name='antmedAprespRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedAprespRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAprespRadNo'>
                      <input
                        id='antmedAprespRadNo'
                        name='antmedAprespRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedAprespRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedAprespEspKey}>
                  <label htmlFor='antmedAprespEsp'>
                    Especificar enfermedad del aparato respiratorio
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedAprespEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedAprespOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAprespOtr'
                      type='text'
                      readOnly
                      value={antmedAprespOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfcardRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad cardiaca?
                    </label>
                    <label className='radio' htmlFor='antmedEnfcardRadSi'>
                      <input
                        id='antmedEnfcardRadSi'
                        name='antmedEnfcardRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfcardRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfcardRadNo'>
                      <input
                        id='antmedEnfcardRadNo'
                        name='antmedEnfcardRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfcardRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfcardEspKey}>
                  <label htmlFor='antmedEnfcardEsp'>
                    Especificar enfermedad cardiaca
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfcardEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfcardOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfcardOtr'
                      type='text'
                      readOnly
                      value={antmedEnfcardOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfvascRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad vascular?
                    </label>
                    <label className='radio' htmlFor='antmedEnfvascRadSi'>
                      <input
                        id='antmedEnfvascRadSi'
                        name='antmedEnfvascRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfvascRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfvascRadNo'>
                      <input
                        id='antmedEnfvascRadNo'
                        name='antmedEnfvascRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfvascRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfvascEspKey}>
                  <label htmlFor='antmedEnfvascEsp'>
                    Especificar enfermedad vascular
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfvascEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfvascOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfvascOtr'
                      type='text'
                      readOnly
                      value={antmedEnfvascOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfdigestRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad digestiva?
                    </label>
                    <label className='radio' htmlFor='antmedEnfdigestRadSi'>
                      <input
                        id='antmedEnfdigestRadSi'
                        name='antmedEnfdigestRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfdigestRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfdigestRadNo'>
                      <input
                        id='antmedEnfdigestRadNo'
                        name='antmedEnfdigestRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfdigestRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfdigestEspKey}>
                  <label htmlFor='antmedEnfdigestEsp'>
                    Especificar enfermedad digestiva
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfdigestEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfdigestOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfdigestOtr'
                      type='text'
                      readOnly
                      value={antmedEnfdigestOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfintestRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alteración del tracto intestinal?
                    </label>
                    <label className='radio' htmlFor='antmedEnfintestRadSi'>
                      <input
                        id='antmedEnfintestRadSi'
                        name='antmedEnfintestRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfintestRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfintestRadNo'>
                      <input
                        id='antmedEnfintestRadNo'
                        name='antmedEnfintestRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfintestRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfintestEspKey}>
                  <label htmlFor='antmedEnfintestEsp'>
                    Especificar alteración del tracto intestinal
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfintestEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfintestOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfintestOtr'
                      type='text'
                      readOnly
                      value={antmedEnfintestOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfpancRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad del páncreas o del
                      hígado?
                    </label>
                    <label className='radio' htmlFor='antmedEnfpancRadSi'>
                      <input
                        id='antmedEnfpancRadSi'
                        name='antmedEnfpancRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfpancRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfpancRadNo'>
                      <input
                        id='antmedEnfpancRadNo'
                        name='antmedEnfpancRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfpancRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfpancEspKey}>
                  <label htmlFor='antmedEnfpancEsp'>
                    Especificar enfermedad del páncreas o del hígado
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfpancEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfpancOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfpancOtr'
                      type='text'
                      readOnly
                      value={antmedEnfpancOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfrenalRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad renal?
                    </label>
                    <label className='radio' htmlFor='antmedEnfrenalRadSi'>
                      <input
                        id='antmedEnfrenalRadSi'
                        name='antmedEnfrenalRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfrenalRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfrenalRadNo'>
                      <input
                        id='antmedEnfrenalRadNo'
                        name='antmedEnfrenalRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfrenalRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfrenalEspKey}>
                  <label htmlFor='antmedEnfrenalEsp'>
                    Especificar enfermedad renal
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfrenalEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfrenalOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfrenalOtr'
                      type='text'
                      readOnly
                      value={antmedEnfrenalOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfurinRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre enfermedad en las vías urinarias?
                    </label>
                    <label className='radio' htmlFor='antmedEnfurinRadSi'>
                      <input
                        id='antmedEnfurinRadSi'
                        name='antmedEnfurinRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfurinRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfurinRadNo'>
                      <input
                        id='antmedEnfurinRadNo'
                        name='antmedEnfurinRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfurinRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfurinEspKey}>
                  <label htmlFor='antmedEnfurinEsp'>
                    Especificar enfermedad en las vías urinarias
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfurinEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfurinOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfurinOtr'
                      type='text'
                      readOnly
                      value={antmedEnfurinOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfgenitRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre enfermedad del aparato genital?
                    </label>
                    <label className='radio' htmlFor='antmedEnfgenitRadSi'>
                      <input
                        id='antmedEnfgenitRadSi'
                        name='antmedEnfgenitRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfgenitRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfgenitRadNo'>
                      <input
                        id='antmedEnfgenitRadNo'
                        name='antmedEnfgenitRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfgenitRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfgenitEspKey}>
                  <label htmlFor='antmedEnfgenitEsp'>
                    Especificar enfermedad del aparato genital
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfgenitEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfgenitOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfgenitOtr'
                      type='text'
                      readOnly
                      value={antmedEnfgenitOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedAltmenstRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alteraciones en la menstruación?
                    </label>
                    <label className='radio' htmlFor='antmedAltmenstRadSi'>
                      <input
                        id='antmedAltmenstRadSi'
                        name='antmedAltmenstRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedAltmenstRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAltmenstRadNo'>
                      <input
                        id='antmedAltmenstRadNo'
                        name='antmedAltmenstRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedAltmenstRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedAltmenstEspKey}>
                  <label htmlFor='antmedAltmenstEsp'>
                    Especificar alteraciones en la menstruación
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedAltmenstEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedAltmenstOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAltmenstOtr'
                      type='text'
                      readOnly
                      value={antmedAltmenstOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEmbarzRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha tenido algún embarazo?
                    </label>
                    <label className='radio' htmlFor='antmedEmbarzRadSi'>
                      <input
                        id='antmedEmbarzRadSi'
                        name='antmedEmbarzRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEmbarzRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEmbarzRadNo'>
                      <input
                        id='antmedEmbarzRadNo'
                        name='antmedEmbarzRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEmbarzRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedEmbarzEsp'>Especificar embarazo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEmbarzEsp'
                      type='text'
                      readOnly
                      value={antmedEmbarzEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antmedAbortRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha tenido algún aborto?
                    </label>
                    <label className='radio' htmlFor='antmedAbortRadSi'>
                      <input
                        id='antmedAbortRadSi'
                        name='antmedAbortRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedAbortRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAbortRadNo'>
                      <input
                        id='antmedAbortRadNo'
                        name='antmedAbortRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedAbortRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedAbortEsp'>Especificar aborto</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAbortEsp'
                      type='text'
                      readOnly
                      value={antmedAbortEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antmedEnfmetabRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad metabólica?
                    </label>
                    <label className='radio' htmlFor='antmedEnfmetabRadSi'>
                      <input
                        id='antmedEnfmetabRadSi'
                        name='antmedEnfmetabRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfmetabRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfmetabRadNo'>
                      <input
                        id='antmedEnfmetabRadNo'
                        name='antmedEnfmetabRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfmetabRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfmetabEspKey}>
                  <label htmlFor='antmedEnfmetabEsp'>
                    Especificar enfermedad metabólica
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfmetabEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfmetabOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfmetabOtr'
                      type='text'
                      readOnly
                      value={antmedEnfmetabOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfpielRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad de piel o faneras?
                    </label>
                    <label className='radio' htmlFor='antmedEnfpielRadSi'>
                      <input
                        id='antmedEnfpielRadSi'
                        name='antmedEnfpielRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfpielRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfpielRadNo'>
                      <input
                        id='antmedEnfpielRadNo'
                        name='antmedEnfpielRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfpielRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfpielEspKey}>
                  <label htmlFor='antmedEnfpielEsp'>
                    Especificar enfermedad de piel o faneras
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfpielEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfpielOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfpielOtr'
                      type='text'
                      readOnly
                      value={antmedEnfpielOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfhematRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad hematológica?
                    </label>
                    <label className='radio' htmlFor='antmedEnfhematRadSi'>
                      <input
                        id='antmedEnfhematRadSi'
                        name='antmedEnfhematRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfhematRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfhematRadNo'>
                      <input
                        id='antmedEnfhematRadNo'
                        name='antmedEnfhematRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfhematRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfhematEspKey}>
                  <label htmlFor='antmedEnfhematEsp'>
                    Especificar enfermedad hematológica
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfhematEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfhematOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfhematOtr'
                      type='text'
                      readOnly
                      value={antmedEnfhematOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedEnfsncsnpRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna enfermedad SNC o SNP?
                    </label>
                    <label className='radio' htmlFor='antmedEnfsncsnpRadSi'>
                      <input
                        id='antmedEnfsncsnpRadSi'
                        name='antmedEnfsncsnpRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedEnfsncsnpRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedEnfsncsnpRadNo'>
                      <input
                        id='antmedEnfsncsnpRadNo'
                        name='antmedEnfsncsnpRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedEnfsncsnpRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedEnfsncsnpEspKey}>
                  <label htmlFor='antmedEnfsncsnpEsp'>
                    Especificar enfermedad SNC o SNP
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedEnfsncsnpEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedEnfsncsnpOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedEnfsncsnpOtr'
                      type='text'
                      readOnly
                      value={antmedEnfsncsnpOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedAltsuenRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha presentado o presenta alteraciones del sueño?
                    </label>
                    <label className='radio' htmlFor='antmedAltsuenRadSi'>
                      <input
                        id='antmedAltsuenRadSi'
                        name='antmedAltsuenRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedAltsuenRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAltsuenRadNo'>
                      <input
                        id='antmedAltsuenRadNo'
                        name='antmedAltsuenRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedAltsuenRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedAltsuenEspKey}>
                  <label htmlFor='antmedAltsuenEsp'>
                    Especificar alteraciones del sueño
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedAltsuenEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedAltsuenOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAltsuenOtr'
                      type='text'
                      readOnly
                      value={antmedAltsuenOtr}
                    />
                  </div>
                </div>


                <div
                  className='field key'
                  data-key={antmedAltapetRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha presentado o presenta alteraciones del apetito?
                    </label>
                    <label className='radio' htmlFor='antmedAltapetRadSi'>
                      <input
                        id='antmedAltapetRadSi'
                        name='antmedAltapetRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedAltapetRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAltapetRadNo'>
                      <input
                        id='antmedAltapetRadNo'
                        name='antmedAltapetRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedAltapetRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedAltapetEsp'>
                    Especificar alteraciones del apetito
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAltapetEsp'
                      type='text'
                      readOnly
                      value={antmedAltapetEsp}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedAltsexRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha presentado o presenta alteraciones en su actividad
                      sexual?
                    </label>
                    <label className='radio' htmlFor='antmedAltsexRadSi'>
                      <input
                        id='antmedAltsexRadSi'
                        name='antmedAltsexRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedAltsexRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedAltsexRadNo'>
                      <input
                        id='antmedAltsexRadNo'
                        name='antmedAltsexRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedAltsexRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedAltsexEspKey}>
                  <label htmlFor='antmedAltsexEsp'>
                    Especificar alteraciones de la actividad sexual
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedAltsexEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedAltsexOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedAltsexOtr'
                      type='text'
                      readOnly
                      value={antmedAltsexOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedPatoculRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna patología ocular?
                    </label>
                    <label className='radio' htmlFor='antmedPatoculRadSi'>
                      <input
                        id='antmedPatoculRadSi'
                        name='antmedPatoculRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedPatoculRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedPatoculRadNo'>
                      <input
                        id='antmedPatoculRadNo'
                        name='antmedPatoculRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedPatoculRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedPatoculEspKey}>
                  <label htmlFor='antmedPatoculEsp'>
                    Especificar patología ocular
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedPatoculEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedPatoculOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedPatoculOtr'
                      type='text'
                      readOnly
                      value={antmedPatoculOtr}
                    />
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antmedPatauditRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna patología auditiva?
                    </label>
                    <label className='radio' htmlFor='antmedPatauditRadSi'>
                      <input
                        id='antmedPatauditRadSi'
                        name='antmedPatauditRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedPatauditRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedPatauditRadNo'>
                      <input
                        id='antmedPatauditRadNo'
                        name='antmedPatauditRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedPatauditRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock' data-key={antmedPatauditEspKey}>
                  <label htmlFor='antmedPatauditEsp'>
                    Especificar patología auditiva
                  </label>
                  <div className='control'>
                    <Select
                      isMulti
                      className='basic-multi-select'
                      classNamePrefix='select'
                      readOnly
                      isDisabled
                      value={antmedPatauditEsp}
                    />
                  </div>
                </div>
                <div className='field sublock'>
                  <label htmlFor='antmedPatauditOtr'>
                    Especificar otros
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedPatauditOtr'
                      type='text'
                      readOnly
                      value={antmedPatauditOtr}
                    />
                  </div>
                </div>


                <div
                  className='field key'
                  data-key={antmedPatolfRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sufrido o sufre alguna patología olfativa?
                    </label>
                    <label className='radio' htmlFor='antmedPatolfRadSi'>
                      <input
                        id='antmedPatolfRadSi'
                        name='antmedPatolfRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antmedPatolfRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antmedPatolfRadNo'>
                      <input
                        id='antmedPatolfRadNo'
                        name='antmedPatolfRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antmedPatolfRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antmedPatolfEsp'>
                    Especificar patología olfativa
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antmedPatolfEsp'
                      type='text'
                      readOnly
                      value={antmedPatolfEsp}
                    />
                  </div>
                </div>
              </div>
              <div className='field'>
                <label className='' htmlFor='antmedObs'>
                  Observaciones
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='antmedObs'
                    id='antmedObs'
                    readOnly
                    value={antmedObs}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72 && props.userRole.includes('medicina')) || props.userRole.includes('administrador')) && (
        <Link className='button is-link' to={`edit`}>
          Editar
        </Link>
      )}
      </div>
      }
    </>
  );
}